﻿function refreshHeader() {
    const header = document.querySelector("header");
    if (!header) return;

    const isScrolled = window.scrollY > 0;
    header.classList.toggle("active", isScrolled);
}

export function initHeaderState() {
    refreshHeader();
    window.addEventListener("scroll", refreshHeader, { passive: true });

    const siteHeader = document.querySelector(".site-header");
    const collapse = siteHeader?.querySelector(".navbar-collapse");
    const toggler = siteHeader?.querySelector(".navbar-toggler");

    if (!collapse || !toggler) return;

    const syncMenuState = (isOpen) => {
        siteHeader.classList.toggle("is-menu-open", isOpen);
        document.body.classList.toggle("mobile-menu-open", isOpen);
        toggler.setAttribute("aria-expanded", String(isOpen));
    };

    collapse.addEventListener("show.bs.collapse", () => syncMenuState(true));
    collapse.addEventListener("hide.bs.collapse", () => syncMenuState(false));

    collapse.querySelectorAll("a.nav-link").forEach((link) => {
        link.addEventListener("click", () => {
            if (!collapse.classList.contains("show") || !window.bootstrap?.Collapse) return;

            window.bootstrap.Collapse.getOrCreateInstance(collapse).hide();
        });
    });

    window.addEventListener("resize", () => {
        if (window.innerWidth >= 768 && collapse.classList.contains("show")) {
            window.bootstrap?.Collapse?.getOrCreateInstance(collapse).hide();
        }
    });
}
